import {
	POST_SCHEDULES,
	POST_SCHEDULES_ERROR,
	POST_SCHEDULES_SUCCESS,
} from '../../../constants';

export const postSchedulesReducer = (state, actions) => {
	switch (actions.type) {
		case POST_SCHEDULES:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_SCHEDULES_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_SCHEDULES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				schedules: actions.payload,
			};
		default:
			return state;
	}
};
